import { render, staticRenderFns } from "./ImageItem.vue?vue&type=template&id=b9b597ba&scoped=true&"
import script from "./ImageItem.vue?vue&type=script&lang=js&"
export * from "./ImageItem.vue?vue&type=script&lang=js&"
import style0 from "./ImageItem.vue?vue&type=style&index=0&id=b9b597ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b597ba",
  null
  
)

export default component.exports